import { DropdownButtonType, FilteringList, FilteringListProps, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';

import { IScheduleInfo } from '~src/schedule/types/IScheduleInfo';

import { Messages } from '../../codegen/Localize';
import { ISchedule, ScheduleActions } from '../../schedule/types/ISchedule';
import { SliceableHelper } from '../../ts/helpers/SliceableHelper';
import { SchedulesService } from '../../ts/resources/Schedules';

export type FlowRunSchedulePickerProps = {
  readonly scheduleId: string;
  readonly onSelect: (value: string) => void;
  readonly label?: string;
};

export type FlowRunSchedulePickerState = {
  readonly listItems: ListItem[];
  readonly filteredList: ListItem[];
  readonly searchText: string;
};

const filteringListStyle: React.CSSProperties = {
  maxHeight: '200px',
  paddingLeft: '0px',
  paddingRight: '0px',
  overflowY: 'auto'
};

export class FlowRunSchedulePicker extends React.PureComponent<FlowRunSchedulePickerProps, FlowRunSchedulePickerState> {
  constructor(props: FlowRunSchedulePickerProps) {
    super(props);
    this.state = { listItems: [], filteredList: [], searchText: '' };
    const schedulesQuery = SchedulesService.all();
    const filteredSchedules = schedulesQuery.addFilter(SchedulesService.filterByActionType(ScheduleActions.Flow));
    SliceableHelper.fetchAll(filteredSchedules).then(schedules => {
      const listItems: ListItem[] = [];
      schedules.items.forEach((item) => {
        listItems.push(this.createListItem(item));
      });
      this.setState({ listItems: listItems, filteredList: listItems });
    });
  }

  private createListItem(item: ISchedule): ListItem {
    const scheduleText = `${item.name} \u2014 ${IScheduleInfo.getScheduleDescription(item)}`;
    return {
      content: scheduleText,
      tooltip: scheduleText,
      value: item.id
    };
  }

  private onFilterChange = (filterValue: string) => {
    const filteredList = this.state.listItems.filter(item => {
      return item.content && (item.content as string).toLowerCase().indexOf(filterValue.toLowerCase()) >= 0;
    });
    this.setState({filteredList, searchText: filterValue});
  }

  private getScheduleTextFromId(id: string): string {
    return id && this.state.listItems.length !== 0 ?
      this.state.listItems.find(item => item.value === id).content as string
      : Messages.selectASchedule();
  }

  public render(): JSX.Element {

    const listProps: FilteringListProps = {
      items: this.state.filteredList,
      autoFocus: true,
      inputTestId: 'flow-run-schedule-picker',
      listTestId: 'flow-run-schedule-picker-list',
      searchPlaceholder: Messages.search(),
      onFilterChange: this.onFilterChange,
      searchText: this.state.searchText
    };

    return (
      <SingleSelectDropdown
        list={<FilteringList {...listProps} style={filteringListStyle} />}
        value={this.props.scheduleId}
        type={DropdownButtonType.Outline}
        onChange={this.props.onSelect}
        label={this.props.label}
      >
        <div style={{whiteSpace: 'nowrap'}}>{this.getScheduleTextFromId(this.props.scheduleId)}</div>
      </SingleSelectDropdown>
    );
  }
}
